export class ComponentProject {
  id: number;
  companyPartNumber: string;
  nomenclature: string;
  assessDate: Date;
  buildDate: Date;
  launchDate: Date;
  evaluationDate: Date;
  evaluationComplete: boolean;
  nextEvaluationDate: Date;
  timesEvaluated: number;
  responsibleParty: string;
  supportParty: string;
  mainType: string;
  additionalType: string;
  currentStatus: string;
  mxAlertCount: number;
  fimCount: number;
  ammCount: number;
  cmmCount: number;
  melCount: number;
  poshCount: number;
  wicCount: number;
  eoCount: number;
  eaCount: number;
  pmaCount: number;
  derCount: number;
  newPartCount: number;
  newVendorCount: number;
  ataChapter: string;
  ataSubChapter: string;
  ataDesc: string;
  ataGroup: string;
  cashItem: boolean;
  majorFleet: string;
  multiFleet: boolean;
  rpiAtAssess: number;
  rpiAtEval?: any;
  enteredAt: Date;
  updatedAt: Date;
  enteredBy: string;
  updatedBy: string;
  contacts: string;
  fleets: string;
  closed: boolean;
  cancelled: boolean;
  attachments: string;
}
